import { PROTOCOL_TEST_IDS } from '@/components/admin/protocoles/contracts';
import { FarewellOption } from '@/components/admin/protocoles/step/farewell-option';
import { HideObjectivesOption } from '@/components/admin/protocoles/step/hide-objectives-option';
import { RereadOption } from '@/components/admin/protocoles/step/reread-option';
import type { ProtocolStepDraft } from '@matter_extractor/shared';

/**
 * The OPTIONS of a step, as a small list of boxes under its name (issue #163;
 * maquette `adieu/etape-adieu.html`, variante A, retained in review on
 * 2026-09-28).
 *
 * A list on purpose: the second option, « À l'entrée, relire l'étape d'où
 * l'on vient » (issue #165), « se range sous la case d'adieu, dans la même
 * liste » (§7.2) - closed on a farewell step, which has no objectives. It came
 * as one `<li>` more and not as a second place where a step's options live,
 * which is what sank variante C.
 *
 * The third option, « Cacher les objectifs à l'interviewer » (issue #191, §4.3;
 * maquette `scenario-succes-conduite/EtapeObjectifsCaches.html`), is one `<li>`
 * more again, under the reread box and closed on a farewell step like it.
 *
 * Indented to the NAME and not to the rank: the box belongs to the step's
 * identity, and aligned under the rank it would read as a line of the frise.
 */

export interface StepOptionsProps {
  readonly step: ProtocolStepDraft;
  readonly readOnly: boolean;
  readonly onChangeStep: (next: ProtocolStepDraft) => void;
}

export function StepOptions({ step, readOnly, onChangeStep }: StepOptionsProps) {
  return (
    <ul data-testid={PROTOCOL_TEST_IDS.stepOptions} className="grid gap-2 sm:ml-11">
      <li>
        <FarewellOption step={step} readOnly={readOnly} onChangeStep={onChangeStep} />
      </li>
      <li>
        <RereadOption step={step} readOnly={readOnly} onChangeStep={onChangeStep} />
      </li>
      <li>
        <HideObjectivesOption step={step} readOnly={readOnly} onChangeStep={onChangeStep} />
      </li>
    </ul>
  );
}
